import React, { useState, FC } from 'react';
import camelCaseKeys from 'camelcase-keys';
import cls from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { create as createCartItem } from 'src/explore/data/cart/cart_items/actions';
import { useRoutes } from 'src/explore/hooks/useRoutes';
import { IStore } from 'src/explore/types/store';
import { ISubCart } from 'src/explore/types/shoppe';
import { Spinner } from 'src/shoppe/elements/Spinner';

import styles from './index.module.sass';

interface ISendAsGiftProps {
  isDisabled: boolean;
  isEgiftable: boolean;
  isEgiftingCheckoutEnabled: boolean;
  isMultiRecipientCheckoutEnabled: boolean;
  productId: number;
}

export const SendAsGift: FC<ISendAsGiftProps> = ({
  isDisabled,
  isEgiftable,
  isEgiftingCheckoutEnabled,
  isMultiRecipientCheckoutEnabled,
  productId,
}) => {
  const [ isAddingToCart, setIsAddingToCart ] = useState<boolean>( false );

  const dispatch = useDispatch();
  const routes = useRoutes();

  const hasGiftCardInCart = useSelector(( state: IStore ) => state.data.cart?.containsGiftCard );
  const cart = camelCaseKeys(
    useSelector(( state: IStore ) => state.data.cart?.data ),
    { deep: true }
  );

  const isGiftable = isMultiRecipientCheckoutEnabled || ( isEgiftingCheckoutEnabled && isEgiftable );

  if ( hasGiftCardInCart || !isGiftable ) return null;

  const isProductInCart = () => {
    if ( !cart?.subcarts?.length ) return false;
    return cart.subcarts.some(( subcart: ISubCart ) =>
      subcart.cartItems.some(( item: any ) => item.product.id === productId )
    );
  };

  const handleClick = async ( event: React.MouseEvent<HTMLButtonElement> ) => {
    event.preventDefault();

    const redirect = routes.giftPurchase.root();

    if ( isProductInCart()) {
      window.location.href = redirect;
      return;
    }

    setIsAddingToCart( true );

    try {
      // makes me sick, but lets go to gbx and just write a test for now
      const form = document.querySelector( '.js__product-form' ) as HTMLFormElement;
      if ( form ) {
        const formData = new FormData( form );
        const params = new URLSearchParams( formData as any ).toString();

        await dispatch( createCartItem( params ) as any );

        window.location.href = redirect;
      }
    } catch ( error ) {
      console.error( 'Error adding to cart:', error );
    } finally {
      setIsAddingToCart( false );
    }
  };

  return (
    <button
      className={cls(
        'v2-form__btn v2-form__btn--outline btn-outline-secondary v2-form__btn--block font-weight-bold py-3 px-6 mt-2 d-flex justify-content-center align-items-center spec__send-as-gift-button',
        styles.button
      )}
      disabled={isDisabled || isAddingToCart}
      type="button"
      onClick={handleClick}
    >
      {isAddingToCart && <Spinner className={cls( 'spinner-border mr-2', styles.spinner )} />}
      Send as Gift
    </button>
  );
};
